module.exports = __webpack_public_path__ + "h5/img/user_sign.2d819a5a.png";